import { GenderDiversity } from 'components/employee-analytics/analytic-item/GenderDiversity'
import { capitalize } from 'utils/utils'
import { useState, useEffect } from 'react'
import { useFetch } from 'services/useFetch'
import { API_EMPLOYEE_ANALYTICS } from 'services/apiEmployeeAnalytics'

const INITIAL_FILTER = {
    employee_type: null,
    company_ids: [],
    department_ids: [],
    division_ids: [],
    sub_division_ids: [],
}

const GenderDiversityContainer = () => {
    const { fetching: getGenderDiversity, isLoading } = useFetch(API_EMPLOYEE_ANALYTICS.GENDER_DIVERSITY)
    const [genderDiversityData, setGenderDiversityData] = useState({})
    const [filter, setFilter] = useState(INITIAL_FILTER)

    const styleBar = (key) => {
        switch (key) {
            case 'male':
                return { fill: '#116584', color: 'bg-[#116584]' }
            case 'female':
                return { fill: '#ee46bc', color: 'bg-[#ee46bc]' }
            default:
                return { fill: '#97a2b6', color: 'bg-[#97a2b6]' }
        }
    }

    useEffect(() => {
        ;(async () => {
            const genderDiversity = await getGenderDiversity(filter)
            const newData = {
                ...genderDiversity?.data,
                detail: genderDiversity?.data?.detail?.map((item) => ({
                    ...item,
                    gender: capitalize(item?.gender),
                    ...styleBar(item?.gender),
                })),
            }

            setGenderDiversityData(newData)
        })()
    }, [filter])

    const onSubmitFilter = (newFilter) => {
        if (JSON.stringify(filter) !== JSON.stringify(newFilter)) {
            setFilter(newFilter)
        }
    }

    const props = {
        data: genderDiversityData,
        isLoading,
        filter,
        onSubmitFilter,
    }

    return <GenderDiversity {...props} />
}

export default GenderDiversityContainer
